export default __webpack_public_path__ + "bdb324fdd375541666e77cf2af4b76df.png";